import axios from "axios";

const API_BASE = '/onsite-drycleaning/clsystem/api/v1';

export function fetchDrives(params = {}) {
    return axios.get(API_BASE + '/drive', {params: params})
}

export function fetchZones(params = {}) {
    return axios.get('/geo/api/v1/zone', {params: params})
}
